<template>
  <div class="PricesSection">
    <div class="PricesSection-mockText">
      <p>{{ mockText }}</p>
      <p>{{ mockText }}</p>
    </div>
    <div class="PricesSection-images">
      <img
        ref="images"
        v-for="(img, index) in imagesData"
        :key="index"
        :src="img.src"
        :style="img.style"
        :class="imageClass(img.id)"
      />
    </div>
    <div class="PricesSection-content" v-observe-visibility="onIntersect">
      <div
        v-for="(item, index) in items"
        :key="key(index)"
        :class="`PricesSection-item ${modifiers(index)}`"
        v-observe-visibility="onIntersectItem"
      >
        <h2>{{ item.year }}</h2>
        <h4>{{ item.title }}</h4>
      </div>
    </div>
  </div>
</template>

<script>
import { TweenMax } from "gsap";
import { sectionImgs } from "@/data/pricesImages";

export default {
  name: "PricesSection",
  props: {
    section: Object,
    mockText: String,
    sectionId: Number,
  },
  data: () => ({
    direction: 1,
    lastY: 0,
    sectionImgs,
  }),
  methods: {
    imageClass(src) {
      const className = `PricesSection-images-${src}`;
      return className;
    },
    onIntersect(isVisible, entry) {
      const { sectionId, lastY } = this;
      const currentY = entry.boundingClientRect.y;
      this.direction = lastY < currentY ? -1 : 1;
      this.lastY = currentY;

      if (isVisible) this.$emit("activeChange", sectionId + 1);
    },
    onIntersectItem(isVisible, entry) {
      if (isVisible) {
        const { direction } = this;
        entry.target.children.forEach((child, index) => {
          const delay = 0.3 + index * 0.1;

          TweenMax.fromTo(
            child,
            0.5,
            {
              autoAlpha: 0,
              y: 30 * direction,
            },
            {
              autoAlpha: 1,
              y: 0,
              delay: delay,
              ease: "power2.easeInOut",
            },
          );
        });
      } else {
        entry.target.children.forEach(child => {
          TweenMax.to(child, 0.2, {
            autoAlpha: 0,
            ease: "power2.easeInOut",
          });
        });
      }
    },
    key(index) {
      return `PricesSection-item-${index}`;
    },
    modifiers(index) {
      const { sectionId } = this;
      const even = "PricesSection-item-red";
      const odd = "PricesSection-item-yellow";
      const className =
        index % 2 !== 0 ? (sectionId % 2 === 0 ? even : odd) : "";
      return className;
    },
  },
  computed: {
    items() {
      const { items } = this.section;
      return items;
    },
    assets() {
      const { assets } = this.section;
      return assets;
    },
    imagesData() {
      const { sectionId, assets, sectionImgs } = this;
      return assets.map(asset => {
        const paddedIndex = `${sectionId}`.padStart(2, "0");
        const imageKey = `${paddedIndex}/${asset.id}`;
        return {
          src: sectionImgs[imageKey],
          style: asset.style,
          id: asset.id,
        };
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './PricesSection.styl';
</style>
